<template>
  <v-timeline dense align-top>
    <v-timeline-item
      v-for="(f, i) in renderedFamilies"
      :key="i"
      :color="
        f.isValidationSuccess
          ? 'success'
          : currentPos === i
          ? 'primary'
          : 'grey'
      "
      :icon="
        f.isValidationSuccess
          ? currentPos === i
            ? 'mdi-check'
            : 'mdi-checkbox-marked-circle'
          : ''
      "
      small
    >
      <a
        :id="currentPos === i ? 'current-fam' : ''"
        :class="currentPos === i ? 'primary--text font-weight-bold' : ''"
        class="line-clamp-2"
        @click="goToFamily(i)"
      >
        {{ f.label }}
      </a>
    </v-timeline-item>
    <v-timeline-item
      :key="renderedFamilies.length"
      :color="
        isAllValidationSuccess
          ? 'success'
          : isCurrentPosReview
          ? 'primary'
          : 'grey'
      "
      :icon="
        isAllValidationSuccess
          ? isCurrentPosReview
            ? 'mdi-check'
            : 'mdi-checkbox-marked-circle'
          : ''
      "
      small
    >
      <a
        :id="isCurrentPosReview ? 'current-fam' : ''"
        :class="isCurrentPosReview ? 'primary--text font-weight-bold' : ''"
        @click="goToReview()"
      >
        Review Questions
      </a>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
export default {
  mounted() {
    this.scrollToCurrent();
  },
  computed: {
    templateNote() {
      return this.$store.state.notesModule.selectedTemplateNote;
    },
    renderedFamilies() {
      return this.$store.getters["notesModule/getRenderedFamilies"] || [];
    },
    currentPos() {
      if (this.$route.query.familyId) {
        return this.renderedFamilies.findIndex(
          (item) => item.familyId === Number(this.$route.query.familyId)
        );
      } else if (this.$route.name == "ReviewQuestions") {
        return this.renderedFamilies.length;
      }
      return Number(this.$route.query.pos);
    },
    isCurrentPosReview() {
      return this.currentPos === this.renderedFamilies.length;
    },
    isAllValidationSuccess() {
      return this.$store.getters["notesModule/isAllValidationSuccess"] === true;
    },
  },
  methods: {
    goToFamily(index) {
      return this.$router.push({
        name: "TemplateNote",
        query: {
          pos: index,
        },
      });
    },
    async goToReview() {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch("notesModule/loadTemplateNote", {
        templateNoteId: this.templateNote?.templateNoteId,
      });
      this.$store.dispatch("notesModule/validateRenderedFamilies");
      this.$store.commit("uxModule/setShowLoader", false);
      return this.$router.push({
        name: "ReviewQuestions",
      });
    },
    scrollToCurrent() {
      var current = document.getElementById("current-fam");
      if (current) {
        this.$vuetify.goTo(current, {
          container: "#toc",
        });
      }
    },
  },
  watch: {
    currentPos() {
      this.$nextTick(() => {
        this.scrollToCurrent();
      });
    },
  },
};
</script>
<style>
.v-timeline-item {
  cursor: pointer;
}
a {
  display: inline-block; /* Allows padding to work correctly */
  padding: 10px; /* Increases the clickable area */
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
